import {
    ADD_EMAIL,
    ADD_EMAIL_FAILURE,
    ADD_EMAIL_SUCCESS,
    APPROVE_ARTIST,
    APPROVE_ARTIST_FAILURE,
    APPROVE_ARTIST_SUCCESS,
    CHANGE_ARTIST_STATUS,
    CHANGE_ARTIST_STATUS_FAILURE,
    CHANGE_ARTIST_STATUS_SUCCESS,
    DELETE_ARTIST,
    DELETE_ARTIST_FAILURE,
    DELETE_ARTIST_SUCCESS,
    GET_ARTIST_LISTING,
    GET_ARTIST_LISTING_FAILURE,
    GET_ARTIST_LISTING_SUCCESS,
} from "../constants";

export default class ArtistAction {
    static getArtistListing(payload, cb) {
        return {
            type: GET_ARTIST_LISTING,
            payload,
            cb,
        };
    }
    static getArtistListingSuccess(payload) {
        return {
            type: GET_ARTIST_LISTING_SUCCESS,
            payload,
        };
    }
    static getArtistListingFailure() {
        return {
            type: GET_ARTIST_LISTING_FAILURE,
        };
    }

    static changeArtistStatus(id, cb) {
        return {
            type: CHANGE_ARTIST_STATUS,
            id,
            cb,
        };
    }
    static changeArtistStatusSuccess(payload) {
        return {
            type: CHANGE_ARTIST_STATUS_SUCCESS,
            payload,
        };
    }
    static changeArtistStatusFailure() {
        return {
            type: CHANGE_ARTIST_STATUS_FAILURE,
        };
    }

    static deleteArtist(id, cb) {
        return {
            type: DELETE_ARTIST,
            id,
            cb,
        };
    }
    static deleteArtistSuccess(payload) {
        return {
            type: DELETE_ARTIST_SUCCESS,
            payload,
        };
    }
    static deleteArtistFailure() {
        return {
            type: DELETE_ARTIST_FAILURE,
        };
    }

    static addEmail(data, cb) {
        return {
            type: ADD_EMAIL,
            data,
            cb,
        };
    }

    static addEmailSuccess(payload) {
        return {
            type: ADD_EMAIL_SUCCESS,
            payload,
        };
    }

    static addEmailFailure() {
        return {
            type: ADD_EMAIL_FAILURE,
        };
    }

    static approveArtist(data, cb) {
        return {
            type: APPROVE_ARTIST,
            data,
            cb,
        };
    }

    static approveArtistSuccess(payload) {
        return {
            type: APPROVE_ARTIST_SUCCESS,
            payload,
        };
    }

    static approveArtistFailure() {
        return {
            type: APPROVE_ARTIST_FAILURE,
        };
    }

}
